import React, {useEffect, useState} from "react";
import Modal from "../../../../../components/modal/modal";
import {DangerButton, FileInput, SelectInput, TextInput} from "../../../../../components/input/inputs";
import axiosInstance from "../../../../../AxiosInstance";
import styles from "../../../../../styles/main.module.css";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faSave} from "@fortawesome/free-solid-svg-icons";

export default function CreateBankAccountModal({show, setter, reload, seller_uuid}) {
    const [form, setForm] = useState({
        seller_uuid: seller_uuid
    });
    const [currencyOptions, setCurrencyOptions] = useState([]);
    const [bankOptions, setBankOptions] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        axiosInstance.get('currency').then((response) => {
            setCurrencyOptions(response.data.results);
        });
        axiosInstance.get('bank_entity').then((response) => {
            setBankOptions(response.data.results);
        })
    }, [])

    const create = () => {
        if(loading) return;
        setLoading(true);

        let formData = new FormData();
        for(const key in form) {
            formData.append(key, form[key]);
        }

        axiosInstance.post('bank_account/', formData).then((response) => {
            setLoading(false);
            reload();
            setter(false);
        });

        setForm({
            seller_uuid: seller_uuid
        });
    }

    return (
        <Modal name={'Agregar Cuenta Bancaria'} show={show} setter={setter} hideClose={true} size="m">
            <div className={'d-flex justify-content-between'}>
                <div className={'d-flex flex-column'} style={{flexBasis: "49%", paddingRight: '2%', maxWidth: "49%"}}>
                    <TextInput name={'R.U.C. del Titular'} internalName={'holder_tax_number'} form={form} setForm={setForm} grey={true}/>
                    <TextInput name={'Nro. de Cuenta'} internalName={'number'} form={form} setForm={setForm} grey={true}/>
                    <SelectInput name={'Entidad Financiera'} internalName={'bank_id'} form={form} setForm={setForm} grey={true} options={bankOptions.map(x => {return {
                        name: x.name,
                        id: x.id
                    }})}/>
                </div>

                <div className={'d-flex flex-column'} style={{flexBasis: "49%"}}>
                    <TextInput name={'Razón Social del Titular'} internalName={'holder_name'} form={form} setForm={setForm} grey={true}/>
                    <TextInput name={'CCI'} internalName={'cci'} form={form} setForm={setForm} grey={true}/>
                    <SelectInput name={'Moneda'} internalName={'currency_id'} options={currencyOptions.map((x) => {return {
                        name: x.name,
                        id: x.id,
                    }})} form={form} setForm={setForm} grey={true}/>
                </div>
            </div>

            <div>
                <div className={'mt-3'} style={{color: '#333333CC'}}>Estado de Cuenta Bancario (solo subir el encabezado)</div>
                <FileInput form={form} setForm={setForm} name={'Seleccionar archivo “.jpg”, “.png” o “.pdf” menor a 2 MB'} accept={'.pdf,.jpg,.png'}
                           onChange={(event) => {
                               setForm({
                                   ...form,
                                   "bank_report": event.target.files[0]
                               });
                           }}/>
            </div>

            <div className={'d-flex justify-content-center align-items-center align-content-center mt-3'}>
                <div onClick={create} className={styles.modalButton} style={{backgroundColor: "#4A4DBB"}}>
                    <FontAwesomeIcon icon={faSave} className={'pe-2'}/> Guardar
                </div>
                <DangerButton onClick={() => setter(false)} name={'Cerrar'}/>
            </div>
        </Modal>
    );
}